import axios from 'axios';
import {setupInterceptorsTo} from "./Interceptors";

class APIService {
  static token: string | null = null;
  static axios = setupInterceptorsTo(axios.create());
  apiUrl: string;

  // static reloadTokens(token: string) {
  //   APIService.token = token;
  //   APIService.axios.defaults.headers = {
  //     Authorization: 'Bearer ' + APIService.token
  //   };
  // }

  constructor(url: string) {
    this.apiUrl = url;
  }

  protected get call() {
    APIService.token = localStorage.getItem('fielddrive-token');
    APIService.axios.defaults.headers = {
      Authorization: 'Bearer ' + APIService.token,
      'Content-Type': 'application/json',
    };
    return APIService.axios;
  }
}

export default APIService;